import { isTouchDevice } from '../../../../src/js/globals/utils/functions';

class CtaCard {
	cursor: HTMLElement;
	element: HTMLElement;
	inverted: HTMLElement;
	mouseX = 0;
	mouseY = 0;
	cursorX = 0;
	cursorY = 0;
	raf = 0;
	isMouseInside = false;
	isMobile = false;
	isTouch = false;

	constructor(element: HTMLElement) {
		this.element = element;
		this.cursor = element.querySelector('.block-cta-card__cursor') as HTMLElement;
		this.inverted = element.querySelector('.block-cta-card__inverted') as HTMLElement;
	}

	init() {
		this.isMobile = this.isMobileViewport();
		this.isTouch = isTouchDevice();

		window.addEventListener('resize', () => {
			this.resize();
		});

		this.element.addEventListener('mouseenter', (e: MouseEvent) => {
			if (this.isMobile || this.isTouch) {
				return;
			}

			const rect = this.element.getBoundingClientRect();
			this.mouseX = (e instanceof MouseEvent ? e.clientX : 0) - rect.left;
			this.mouseY = (e instanceof MouseEvent ? e.clientY : 0) - rect.top;
			this.cursorX = this.mouseX;
			this.cursorY = this.mouseY;
			this.cursor.style.visibility = 'visible';
			this.cursor.style.opacity = '1';
			this.inverted.style.opacity = '1';
			this.inverted.style.display = 'block';
			this.inverted.style.maskImage = `url("${window.impThemeAssets?.mask}")`;
			this.inverted.style.webkitMaskImage = `url("${window.impThemeAssets?.mask}")`;
			this.isMouseInside = true;
			this.raf = requestAnimationFrame(this.animate.bind(this));
		});

		this.element.addEventListener('mouseleave', () => {
			if (this.isMobile || this.isTouch) {
				return;
			}

			this.isMouseInside = false;
		});

		this.element.addEventListener('mousemove', (e: MouseEvent) => {
			if (this.isMobile || this.isTouch) {
				return;
			}

			const rect = this.element.getBoundingClientRect();
			this.mouseX = e.clientX - rect.left;
			this.mouseY = e.clientY - rect.top;
		});
	}

	resize() {
		this.isMobile = this.isMobileViewport();
		this.isTouch = isTouchDevice();
	}

	animate() {
		if (this.isMobile || this.isTouch) {
			return;
		}

		const cursorSize = 100;
		const maskSize = 100;

		this.cursorX = this.mouseX;
		this.cursorY = this.mouseY;

		this.cursor.style.left = `${this.cursorX - cursorSize / 2}px`;
		this.cursor.style.top = `${this.cursorY - cursorSize / 2}px`;

		const maskPos = `${this.cursorX - maskSize / 2}px ${this.cursorY - maskSize / 2}px`;
		this.inverted.style.maskPosition = maskPos;
		this.inverted.style.webkitMaskPosition = maskPos;

		if (
			!this.isMouseInside &&
			Math.abs(this.cursorX - this.mouseX) < 1 &&
			Math.abs(this.cursorY - this.mouseY) < 1
		) {
			this.cursor.style.visibility = 'hidden';
			this.cursor.style.opacity = '0';
			this.inverted.style.maskPosition = '';
			this.inverted.style.webkitMaskPosition = '';
			this.inverted.style.maskImage = 'none';
			this.inverted.style.webkitMaskImage = 'none';
			this.inverted.style.display = 'none';
			this.inverted.style.opacity = '0';
			cancelAnimationFrame(this.raf);
			return;
		}

		this.raf = requestAnimationFrame(this.animate.bind(this));
	}

	isMobileViewport(): boolean {
		const mediaQuery = window?.impBreakpoints
			? `(max-width: ${parseInt(window?.impBreakpoints.md) - 1}px)`
			: '(max-width: 767px)';
		return window.matchMedia(mediaQuery).matches;
	}
}

document.querySelectorAll('.block-cta-card-split').forEach((element) => {
	element.querySelectorAll('.block-cta-card').forEach((card) => {
		const ctaCard = new CtaCard(card as HTMLElement);
		ctaCard.init();
	});
});
